import { render } from "./FaqSectionTwo.vue?vue&type=template&id=4d0aa790"
import script from "./FaqSectionTwo.vue?vue&type=script&lang=js"
export * from "./FaqSectionTwo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\berdu\\Documents\\cooweb\\parkfactura-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__